import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { takeUntil } from "rxjs";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { FeatureFlag } from "@webapp/feature-toggles/models/feature-toggles.models";
import { FeatureTogglesFacade } from "@webapp/feature-toggles/services/feature-toggles-facade.service";
import { ReflectionMoodType, reflectionMoodTypes } from "@webapp/reflections/models/reflections.models";

@Component({
  selector: "reflection-mood",
  templateUrl: "./reflection-mood.component.html",
  styleUrls: ["./reflection-mood.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReflectionMoodComponent {
  @Input() public isEditModeEnabled: boolean;
  @Input() public reflectionMood: ReflectionMoodType;
  @Output() public readonly moodChange = new EventEmitter<ReflectionMoodType>();

  public reflectionMoodTypes = reflectionMoodTypes;
  public isCheckInsUxImprovementsEnabled: boolean;

  constructor(featureToggleFacade: FeatureTogglesFacade, destroy$: DestroyService) {
    featureToggleFacade
      .isFeatureAvailable$(FeatureFlag.CheckInsUxImprovements)
      .pipe(takeUntil(destroy$))
      .subscribe({
        next: (enabled) => {
          this.isCheckInsUxImprovementsEnabled = enabled;
        },
      });
  }

  public updateMood(mood: ReflectionMoodType): void {
    this.moodChange.emit(mood);
  }
}
